import { render, staticRenderFns } from "./indexAuth.vue?vue&type=template&id=17bcd7dc&scoped=true&"
import script from "./indexAuth.vue?vue&type=script&lang=ts&"
export * from "./indexAuth.vue?vue&type=script&lang=ts&"
import style0 from "./indexAuth.vue?vue&type=style&index=0&id=17bcd7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bcd7dc",
  null
  
)

export default component.exports